
import errorCodes from '../error/errorCodes.json';

export const errorHandleParser = {
    captureErrorMessage
}

function captureErrorMessage(error){
    let errMessage = '';
    if(error.validationFailures?.length){
        const errorCode = error.validationFailures[0].code;
        errMessage = errorCodes[errorCode];
    }

    return errMessage;
}

